import { render, staticRenderFns } from "./MessagingDatatable.vue?vue&type=template&id=bfb8a64e"
import script from "./MessagingDatatable.vue?vue&type=script&lang=js"
export * from "./MessagingDatatable.vue?vue&type=script&lang=js"
import style0 from "./MessagingDatatable.vue?vue&type=style&index=0&id=bfb8a64e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports